// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1e3Gf","title":"Header_title__3QxDk","side":"Header_side__2-vVt"};